<template>
  <div class="treatment-page">
    <div class="hero-section">
      <div class="container">
        <h1>Cosmetische Tandheelkunde Sint-Michielsgestel</h1>
        <p class="lead">Verbeter uw glimlach met cosmetische tandheelkunde bij Tandzorg Gestel. Professionele treatments voor een stralende, zelfverzekerde glimlach.</p>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <h2>Wat is cosmetische tandheelkunde?</h2>
            <p>Cosmetische tandheelkunde richt zich op het verbeteren van de uitstraling van uw tanden en glimlach. Bij Tandzorg Gestel in Sint-Michielsgestel combineren we esthetiek met functionaliteit om u de perfecte glimlach te geven waar u altijd van heeft gedroomd.</p>

            <p>Onze ervaren tandartsen gebruiken de nieuwste technieken en materialen om natuurlijk uitziende resultaten te behalen die passen bij uw gezicht en persoonlijkheid. Van subtiele verbeteringen tot complete smile makeovers - wij helpen u om met vertrouwen te glimlachen.</p>

            <h2>Onze cosmetische behandelingen</h2>
            
            <h3>Tandenbleken (Teeth Whitening)</h3>
            <p>Professioneel tandenbleken voor een stralend witte glimlach. Wij bieden zowel in-office bleaching als take-home bleaching sets aan. Onze bleekmethoden zijn veilig en effectief, met resultaten die tot 8 tinten witter kunnen zijn.</p>

            <h3>Veneers (Facings)</h3>
            <p>Porselein veneers zijn dunne schalen die over de voorkant van uw tanden worden geplaatst. Ze corrigeren vorm, kleur, grootte en uitlijning van tanden. Perfect voor het verhelpen van scheefstand, verkleuring, slijtage of kleine gaatjes.</p>

            <h3>Composite Bonding</h3>
            <p>Een snelle en betaalbare manier om kleine imperfecties te corrigeren. Met tandkleurig compositemateriaal kunnen we:</p>
            <ul>
              <li>Kleine gaatjes tussen tanden sluiten</li>
              <li>Afgebroken stukjes tand herstellen</li>
              <li>Vorm van tanden verbeteren</li>
              <li>Verkleuring maskeren</li>
            </ul>

            <h3>Tandcontouring</h3>
            <p>Door voorzichtig kleine hoeveelheden tandglazuur weg te nemen, kunnen we:</p>
            <ul>
              <li>Puntige hoeken afronden</li>
              <li>Lengte van tanden aanpassen</li>
              <li>Kleine onregelmatigheden gladstrijken</li>
              <li>Symmetrie in uw glimlach creëren</li>
            </ul>

            <h3>Tandvleescorrectie (Gum Contouring)</h3>
            <p>Voor een perfect gebalanceerde glimlach kunnen we de tandvleeslijn aanpassen. Dit is ideaal voor mensen met een "gummy smile" of ongelijke tandvleeslijnen.</p>

            <h2>Het behandelproces</h2>
            
            <h3>Stap 1: Consult en Planning</h3>
            <p>We beginnen met een uitgebreid consult waarin we uw wensen bespreken en een behandelplan opstellen. Met digitale smile design technologie kunnen we u vooraf laten zien hoe uw nieuwe glimlach eruit zal zien.</p>

            <h3>Stap 2: Voorbereiding</h3>
            <p>Indien nodig maken we afdrukken of digitale scans van uw tanden. Voor behandelingen zoals veneers wordt een kleine hoeveelheid tandglazuur weggenomen om ruimte te maken voor het nieuwe materiaal.</p>

            <h3>Stap 3: Behandeling</h3>
            <p>De eigenlijke behandeling wordt uitgevoerd met precisie en aandacht voor detail. We zorgen ervoor dat u zich comfortabel voelt tijdens het hele proces.</p>

            <h3>Stap 4: Nazorg en Onderhoud</h3>
            <p>We geven u uitgebreide instructies voor de verzorging van uw nieuwe glimlach en plannen reguliere controleafspraken.</p>

            <h2>Voordelen van cosmetische tandheelkunde</h2>
            <ul>
              <li><strong>Verhoogd zelfvertrouwen</strong> - een mooie glimlach opent deuren</li>
              <li><strong>Natuurlijke uitstraling</strong> - moderne materialen zijn niet van echte tanden te onderscheiden</li>
              <li><strong>Duurzame resultaten</strong> - met goede verzorging jaren lang genieten</li>
              <li><strong>Snelle transformatie</strong> - vaak al resultaat in één of twee bezoeken</li>
              <li><strong>Betere mondhygiëne</strong> - rechte, mooie tanden zijn makkelijker schoon te houden</li>
            </ul>

            <h2>Geschikt voor wie?</h2>
            <p>Cosmetische tandheelkunde is geschikt voor iedereen die ontevreden is met het uiterlijk van hun glimlach. Denk aan:</p>
            <ul>
              <li>Verkleurde of vlekkerige tanden</li>
              <li>Scheefstaande tanden (lichte gevallen)</li>
              <li>Gaatjes tussen tanden</li>
              <li>Afgebroken of gechipt tanden</li>
              <li>Ongelijke tandlengtes</li>
              <li>Tanden die te klein of te groot lijken</li>
            </ul>

            <h2>Kosten en financiering</h2>
            <p>De kosten van cosmetische tandheelkunde variëren per behandeling. Tijdens uw consult krijgt u een transparante kostenopgave. We bieden verschillende betaalmogelijkheden aan en helpen u bij het afsluiten van een verzekering voor cosmetische behandelingen.</p>

            <h2>Waarom Tandzorg Gestel kiezen?</h2>
            <ul>
              <li><strong>Ervaren cosmetische tandartsen</strong> in Sint-Michielsgestel</li>
              <li><strong>Digitale smile design</strong> - zie uw resultaat vooraf</li>
              <li><strong>Premium materialen</strong> van wereldwijde topmerken</li>
              <li><strong>Persoonlijke benadering</strong> - elke glimlach is uniek</li>
              <li><strong>Uitgebreide nazorg</strong> - levenslange ondersteuning</li>
              <li><strong>Moderne faciliteiten</strong> in comfortabele omgeving</li>
            </ul>
          </div>

          <div class="col-md-4">
            <div class="appointment-card">
              <h3>Gratis Smile Consult</h3>
              <p>Ontdek de mogelijkheden voor uw glimlach tijdens een gratis consult bij Tandzorg Gestel.</p>
              <router-link to="/contact" class="link-btn">Consult aanvragen</router-link>
              <router-link to="/afspraak-maken" class="link-btn">Afspraak maken</router-link>
              
              <div class="contact-info">
                <h4>Contact</h4>
                <p>📞 <a href="tel:+31735515644" class="contact-link">073-5515644</a></p>
                <p>✉️ <a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a></p>
                <p>📍 Schijndelseweg 13A<br>5271 BK Sint-Michielsgestel</p>
              </div>
            </div>

            <div class="treatment-gallery">
              <h4>Voor & Na Resultaten</h4>
              <p>Bekijk onze portfolio van smile transformaties. Elke behandeling wordt op maat gemaakt voor de individuele patiënt.</p>
            </div>

            <div class="related-treatments">
              <h4>Gerelateerde behandelingen</h4>
              <ul>
                <li><router-link to="/wortelkanaalbehandeling">Wortelkanaalbehandeling</router-link></li>
                <li><router-link to="/mondhygiene">Professionele reiniging</router-link></li>
                <li><router-link to="/kronen-bruggen">Kronen en bruggen</router-link></li>
                <li><router-link to="/orthodontie">Orthodontie</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CosmetischeTandheelkunde',
  mounted() {
    // SEO optimization
    document.title = "Cosmetische Tandheelkunde Sint-Michielsgestel | Tandzorg Gestel | Veneers & Bleaching";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Cosmetische tandheelkunde bij Tandzorg Gestel: veneers, tandenbleken, bonding en meer. Transform uw glimlach in Sint-Michielsgestel. Gratis consult.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'cosmetische tandheelkunde, veneers, tandenbleken, teeth whitening, facings, bonding, glimlach verbeteren, tandarts Sint-Michielsgestel');
    }
    
    // Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalProcedure",
      "name": "Cosmetische Tandheelkunde",
      "description": "Cosmetische tandheelkunde behandelingen bij Tandzorg Gestel in Sint-Michielsgestel",
      "provider": {
        "@type": "Dentist",
        "name": "Tandzorg Gestel",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Schijndelseweg 13A",
          "addressLocality": "Sint-Michielsgestel",
          "postalCode": "5271 BK",
          "addressCountry": "NL"
        },
        "telephone": "+31735515644"
      },
      "medicalSpecialty": "Cosmetic Dentistry",
      "includesOperation": [
        "Tandenbleken",
        "Veneers",
        "Composite Bonding",
        "Tandcontouring"
      ]
    });
    document.head.appendChild(script);
  }
}
</script>

<style scoped>
.treatment-page {
  padding-top: 88px;
}

.hero-section {
  background: linear-gradient(135deg, var(--blue), #0099a3);
  color: white;
  padding: 4rem 0;
  text-align: center;
}

.hero-section h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.lead {
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
}

.content-section {
  padding: 4rem 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.row {
  display: flex;
  gap: 3rem;
}

.col-md-8 {
  flex: 2;
}

.col-md-4 {
  flex: 1;
}

.content-section h2 {
  color: var(--blue);
  font-size: 2.2rem;
  margin: 2rem 0 1rem 0;
}

.content-section h3 {
  color: var(--black);
  font-size: 1.5rem;
  margin: 1.5rem 0 0.5rem 0;
}

.content-section p {
  line-height: 1.8;
  margin-bottom: 1rem;
  color: var(--light-color);
  font-size: 1.6rem;
}

.content-section ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.content-section li {
  margin-bottom: 0.5rem;
  color: var(--light-color);
  font-size: 1.6rem;
  line-height: 1.6;
}

.appointment-card {
  background: var(--light-bg);
  padding: 2rem;
  border-radius: 10px;
  margin-bottom: 2rem;
  box-shadow: var(--box-shadow);
}

.appointment-card h3 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.appointment-card .link-btn {
  display: block;
  margin-bottom: 1rem;
  text-align: center;
}

.contact-info {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.contact-info h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.treatment-gallery {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  margin-bottom: 2rem;
}

.treatment-gallery h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.related-treatments {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
}

.related-treatments h4 {
  color: var(--blue);
  margin-bottom: 1rem;
}

.related-treatments ul {
  list-style: none;
  padding: 0;
}

.related-treatments li {
  margin-bottom: 0.5rem;
}

.related-treatments a {
  color: var(--light-color);
  text-decoration: none;
  font-size: 1.4rem;
}

.related-treatments a:hover {
  color: var(--blue);
}

@media (max-width: 768px) {
  .row {
    flex-direction: column;
    gap: 2rem;
  }
  
  .hero-section h1 {
    font-size: 2.5rem;
  }
  
  .lead {
    font-size: 1.1rem;
  }
  
  .content-section {
    padding: 2rem 0;
  }
}
</style>
